export enum OptionYesNoEnum {
    YES = 'Sim',
    NO = 'Não'
}

export type OptionYesNo = 'YES' | 'NO';
